import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Gallery.css";

export default function Gallery() {
  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState([]);
  const [activeCategory, setActiveCategory] = useState("all");

  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const API_BASE = "https://spst.in/myapp/api";
  const IMAGE_BASE = "https://spst.in/myapp/uploads/gallery/";

  /* ===============================
     FETCH CATEGORIES
  =============================== */

  useEffect(() => {
    axios
      .get(`${API_BASE}/fetch_categories.php`)
      .then((res) =>
        setCategories(Array.isArray(res.data) ? res.data : [])
      )
      .catch(() => setCategories([]));
  }, []);

  /* ===============================
     FETCH IMAGES
  =============================== */

  useEffect(() => {
    axios
      .get(
        `${API_BASE}/fetch_gallery.php?category_id=${activeCategory}`
      )
      .then((res) =>
        setImages(Array.isArray(res.data) ? res.data : [])
      )
      .catch(() => setImages([]));
  }, [activeCategory]);

  /* ===============================
     OPEN IMAGE
  =============================== */

  const openImage = (index) => {
    setCurrentIndex(index);
    setShowModal(true);
    document.body.style.overflow = "hidden";
  };

  /* ===============================
     CLOSE
  =============================== */

  const closeModal = () => {
    setShowModal(false);
    document.body.style.overflow = "auto";
  };

  /* ===============================
     NEXT
  =============================== */

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  /* ===============================
     PREVIOUS
  =============================== */

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  /* ===============================
     KEYBOARD
  =============================== */

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!showModal) return;

      if (e.key === "Escape") {
        closeModal();
      }

      if (e.key === "ArrowRight") {
        nextImage();
      }

      if (e.key === "ArrowLeft") {
        prevImage();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showModal, images.length]);

  /* ===============================
     CLEAN BODY
  =============================== */

  useEffect(() => {
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <section className="premium-gallery">

      {/* =================================
          HEADER
      ================================= */}

      {/* <div className="gallery-header">

        <div className="gallery-eyebrow">
          <span>✦</span>
          VISUAL ARCHIVES
          <span>✦</span>
        </div>

        <h1>
          Temple <span>Gallery</span>
        </h1>

        <div className="gallery-decoration">
          <span></span>
          <i>✦</i>
          <span></span>
        </div>

        <p>
          Explore moments, architecture, celebrations and sacred
          glimpses from Sree Padmanabhaswamy Temple.
        </p>

      </div> */}


      {/* =================================
          CATEGORY FILTER
      ================================= */}

      <div className="gallery-filter">

        <button
          className={activeCategory === "all" ? "active" : ""}
          onClick={() => setActiveCategory("all")}
        >
          <span>✦</span>
          All
        </button>

        {categories.map((cat) => (
          <button
            key={cat.id}
            className={
              activeCategory === cat.id ? "active" : ""
            }
            onClick={() => setActiveCategory(cat.id)}
          >
            {cat.category_name}
          </button>
        ))}

      </div>


      {/* =================================
          IMAGE COUNT
      ================================= */}

      <div className="gallery-info">

        {/* <span>
          {images.length}{" "}
          {images.length === 1 ? "Image" : "Images"}
        </span> */}

        <span className="gallery-info-line"></span>

        <span>
          {activeCategory === "all"
            ? "All Collections"
            : categories.find(
                (cat) => cat.id === activeCategory
              )?.category_name}
        </span>

      </div>


      {/* =================================
          GALLERY
      ================================= */}

      <div className="gallery-grid">

        {images.length === 0 ? (

          <div className="gallery-empty">

            <div className="empty-icon">
              ◇
            </div>

            <h3>No Images Found</h3>

            <p>
              There are no images available in this collection.
            </p>

          </div>

        ) : (

          images.map((img, index) => (

            <div
              className={`gallery-item gallery-item-${index % 6}`}
              key={img.id}
              onClick={() => openImage(index)}
            >

              <img
                src={`${IMAGE_BASE}${img.image_name}`}
                alt={img.title || "Temple Gallery"}
                loading="lazy"
              />

              <div className="gallery-overlay">

                <div className="gallery-overlay-content">

                  <span className="gallery-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <span className="gallery-view">
                    ⤢
                  </span>

                </div>

              </div>

            </div>

          ))

        )}

      </div>


      {/* =================================
          LIGHTBOX
      ================================= */}

      {showModal && images.length > 0 && (

        <div
          className="lightbox"
          onClick={(e) => {
            if (e.target.className === "lightbox") {
              closeModal();
            }
          }}
        >

          {/* TOP BAR */}

          <div className="lightbox-top">

            <div className="lightbox-counter">
              <strong>
                {String(currentIndex + 1).padStart(2, "0")}
              </strong>

              <span>/</span>

              <span>
                {String(images.length).padStart(2, "0")}
              </span>
            </div>

            <button
              className="lightbox-close"
              onClick={closeModal}
              aria-label="Close"
            >
              ×
            </button>

          </div>


          {/* PREVIOUS */}

          <button
            className="lightbox-prev"
            onClick={prevImage}
            aria-label="Previous image"
          >
            <span>←</span>
          </button>


          {/* IMAGE */}

          <div className="lightbox-image-container">

            <img
              className="lightbox-img"
              src={`${IMAGE_BASE}${images[currentIndex].image_name}`}
              alt={images[currentIndex].title || "Temple Gallery"}
            />

          </div>


          {/* NEXT */}

          <button
            className="lightbox-next"
            onClick={nextImage}
            aria-label="Next image"
          >
            <span>→</span>
          </button>


          {/* BOTTOM */}

          <div className="lightbox-bottom">

            <span>
              Sree Padmanabhaswamy Temple
            </span>

            <span>
              Use ← → to navigate
            </span>

          </div>

        </div>

      )}

    </section>
  );
}